import { render } from "./onBoardSystemInformation.vue?vue&type=template&id=1913b982&scoped=true&ts=true"
import script from "./onBoardSystemInformation.vue?vue&type=script&lang=ts"
export * from "./onBoardSystemInformation.vue?vue&type=script&lang=ts"

import "./onBoardSystemInformation.vue?vue&type=style&index=0&id=1913b982&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1913b982"]])

export default __exports__